export const AI_ANALISE_DESIGN = {
  page: {
    outer: 'h-full overflow-hidden p-4 w-full',
    container:
      'h-full w-full flex flex-col gap-4 animate-in fade-in slide-in-from-bottom-4 duration-500 min-h-0',
    header: {
      container: 'flex flex-col md:flex-row justify-between items-start md:items-center gap-4',
      iconWrapper: 'w-12 h-12 bg-violet-50 rounded-2xl flex items-center justify-center border border-violet-100',
      title: 'text-2xl font-bold text-gray-900 tracking-tight',
      subtitle: 'text-sm text-gray-500 mt-0.5',
      actions: 'flex items-center gap-2.5',
    },
    actionButton:
      'flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95',
    ghostButton:
      'h-9 w-9 p-0 rounded-xl border border-dashed border-gray-300 text-gray-600 hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-[#7C3AED]/5 transition-all flex items-center justify-center',
  },
  stats: {
    grid: 'grid grid-cols-2 md:grid-cols-4 gap-3',
    card: 'bg-white rounded-xl border border-gray-100 p-4 flex items-center gap-3 hover:shadow-sm transition-shadow',
    iconBox: 'w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0',
    value: 'text-xl font-bold text-gray-900',
    label: 'text-xs text-gray-500',
  },
  filters: {
    grid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3',
    label: 'text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 block',
    select:
      'w-full bg-white border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200 h-10 text-sm',
    searchInput:
      'pl-9 bg-white border-gray-200 focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 rounded-xl transition-all duration-200',
    dateButton:
      'w-full h-10 justify-between text-sm font-normal border-dashed border-gray-300 bg-white hover:border-[#7C3AED] hover:text-[#7C3AED] hover:bg-violet-50 text-gray-700 rounded-xl',
    moreFiltersButton:
      'w-full h-10 px-3 border-dashed border-gray-300 text-sm text-gray-600 hover:border-violet-500 hover:text-violet-600 hover:bg-violet-50 bg-white rounded-xl justify-start',
  },
  table: {
    wrapperCard: 'bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden',
    row: 'group px-6 py-3.5 flex items-center border-b last:border-b-0 border-gray-100 hover:bg-violet-50/40 cursor-pointer transition-colors',
    cellText: 'text-sm text-gray-700',
    cellMuted: 'text-sm text-gray-500',
    copyChip:
      'inline-flex items-center gap-1.5 bg-gray-50 border border-gray-200 rounded-lg px-2.5 py-1 max-w-full',
    copyChipText: 'text-xs text-gray-700 font-mono truncate',
    copyButton:
      'text-gray-400 hover:text-[#7C3AED] hover:bg-violet-100 rounded p-0.5 transition-colors flex items-center justify-center',
    actionButtonView:
      'h-8 w-8 p-0 inline-flex items-center justify-center rounded-lg text-gray-500 hover:bg-violet-100 hover:text-violet-700 transition-colors',
    actionButtonChat:
      'h-8 w-8 p-0 inline-flex items-center justify-center rounded-lg text-gray-500 hover:bg-blue-100 hover:text-blue-700 transition-colors',
  },
  emptyState: {
    container: 'flex flex-col items-center justify-center py-20 px-4',
    iconBox: 'w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-4',
    title: 'text-base font-semibold text-gray-900',
    description: 'text-sm text-gray-500 mt-1',
  },
  loadingBar: {
    track: 'w-full h-1 bg-gray-100 rounded-full overflow-hidden',
    bar: 'h-full bg-[#7C3AED] rounded-full animate-[pulse_1.5s_ease-in-out_infinite]',
  },
  locked: {
    overlay:
      'absolute inset-0 z-50 flex flex-col items-center justify-center bg-white/70 backdrop-blur-sm rounded-xl overflow-hidden transition-all duration-500',
    card:
      'bg-white/95 p-8 rounded-3xl shadow-2xl border border-white/50 text-center max-w-md backdrop-blur-xl relative z-10 animate-in fade-in zoom-in-95 duration-500',
    iconBox:
      'w-16 h-16 bg-gradient-to-br from-violet-50 to-indigo-50 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-sm ring-1 ring-black/5',
    title: 'text-2xl font-bold text-slate-800 mb-3 tracking-tight',
    description: 'text-slate-600 mb-2 leading-relaxed text-sm',
  },
};

export const SENTIMENT_META = {
  5: {
    label: 'Muito satisfeito',
    short: 'Ótimo',
    dot: 'bg-green-500',
    badge: 'bg-green-50 text-green-700 border-green-200',
    bg: 'bg-green-50',
    text: 'text-green-700',
    icon: 'mdi:emoticon-excited-outline',
    tone: 'positive',
  },
  4: {
    label: 'Satisfeito',
    short: 'Bom',
    dot: 'bg-green-500',
    badge: 'bg-green-50 text-green-700 border-green-200',
    bg: 'bg-green-50',
    text: 'text-green-700',
    icon: 'mdi:emoticon-happy-outline',
    tone: 'positive',
  },
  3: {
    label: 'Neutro',
    short: 'Neutro',
    dot: 'bg-amber-500',
    badge: 'bg-amber-50 text-amber-700 border-amber-200',
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    icon: 'mdi:emoticon-neutral-outline',
    tone: 'neutral',
  },
  2: {
    label: 'Insatisfeito',
    short: 'Ruim',
    dot: 'bg-red-500',
    badge: 'bg-red-50 text-red-700 border-red-200',
    bg: 'bg-red-50',
    text: 'text-red-700',
    icon: 'mdi:emoticon-sad-outline',
    tone: 'negative',
  },
  1: {
    label: 'Muito insatisfeito',
    short: 'Péssimo',
    dot: 'bg-red-500',
    badge: 'bg-red-50 text-red-700 border-red-200',
    bg: 'bg-red-50',
    text: 'text-red-700',
    icon: 'mdi:emoticon-cry-outline',
    tone: 'negative',
  },
};

export function getSentimentMeta(sentiment) {
  const value = parseInt(sentiment, 10);
  if (!value || Number.isNaN(value)) {
    return {
      label: 'N/A',
      short: 'N/A',
      dot: 'bg-gray-400',
      badge: 'bg-gray-50 text-gray-600 border-gray-200',
      bg: 'bg-gray-50',
      text: 'text-gray-600',
      icon: 'mdi:help-circle-outline',
      tone: 'neutral',
    };
  }
  return SENTIMENT_META[value] || SENTIMENT_META[3];
}
